import { Component, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ZoneService } from 'src/app/services/modules/instant-rate-manager/zone.service';
import { AlertUtil } from 'src/app/shared/utils/alert-dialog.util';

@Component({
  selector: 'app-custom-zone-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './custom-zone-modal.component.html',
  styleUrl: './custom-zone-modal.component.scss'
})
export class CustomZoneModalComponent {
  public activeModal = inject(NgbActiveModal);
  private zoneService = inject(ZoneService);

  /**
   * STATE
   */
  @Input() zoneName = '';
  postal_code_from = '';
  postal_code_to = '';
  isLoading = false;

  /**
   * ACTIONS
   */
  async saveCustomZone() {
    if (!this.zoneName) {
      AlertUtil.error('Please provide a zone name.');
      return;
    }

    this.isLoading = true;

    const payload = {
      name: this.zoneName,
      postal_code_from: this.postal_code_from || null,
      postal_code_to: this.postal_code_to || null,
      is_custom: true
    };

    try {
      await this.zoneService.createProviderCustomZone(payload);
      AlertUtil.success('Custom zone created successfully!');
      this.activeModal.close(true);
    } catch (error: any) {
      AlertUtil.error(error?.error?.message || 'Failed to create custom zone.');
    } finally {
      this.isLoading = false;
    }
  }
}
